import { useState } from 'react';
import Input from '../Input';
import './create-class.css';
import CloseButton from '../CloseButton';
import { handleErr, isValidVideoEmbed } from '../../utils/functions';
import TextArea from '../TextArea';
import { create } from '../../services/api';
import { useUI } from '../../UIContext';

function CreateClass({ moduleId, onSuccess = () => {}, onClose = () => {} }) {
    const { setLoading, setMessage } = useUI();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [videoUrl, setVideoUrl] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const [hasSavedProcess, setHasSavedProcess] = useState(false);

    function isNameValid() {
        return !!name && name.length >= 3;
    }

    function isDescriptionValid() {
        return !!description && description.length >= 5;
    }

    function isVideoUrlValid() {
        return !!videoUrl && isValidVideoEmbed(videoUrl);
    }

    async function onClickSave(e) {
        e.preventDefault();

        function isSaveValid() {
            setSubmitAttempt(true);

            return isNameValid() && isDescriptionValid() && isVideoUrlValid();
        }

        e.preventDefault();

        if (!isSaveValid())
            return;

        setLoading(true);

        const data = {
            name,
            description,
            videoUrl
        };

        await create(`module/${moduleId}/class`, data, true, setMessage,
            () => {
                setHasSavedProcess(true);
                setMessage({ type: 'success', text: 'A aula foi adicionada.' });
                onSuccess();
            },
            (err) => {
                handleErr(setMessage, `Não foi possível salvar a aula: ${err}`);
            },
            () => {
                setLoading(false);
            }
        );
    }

    return (
        <form className='container-create-class'>
            <header className='container-header'>
                <h1>Nova Aula</h1>

                <CloseButton onClick={(e) => {
                    onClose();
                }} shouldConfirm={!hasSavedProcess} />
            </header>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                onValidate={isNameValid}
                placeholder='Nome'
                shouldValidate={submitAttempt}
                maxLength={100}
                warningMsg='O nome deve conter ao menos 3 caracteres.'
            />

            <TextArea
                cols='4'
                rows='4'
                className='commom-input glass-effect-15'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onValidate={isDescriptionValid}
                placeholder='Descrição'
                shouldValidate={submitAttempt}
                maxLength={1000}
                warningMsg='A descrição deve conter ao menos 5 caracteres.'
            />

            <div className='container-video-preview'>
                {!isVideoUrlValid() && (
                    <div className='no-video-url'>
                        <p>Insira a URL do seu vídeo.</p>
                    </div>
                )}

                {isVideoUrlValid() && (
                    <iframe
                        src={videoUrl}
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        title={name}>
                    </iframe>
                )}
            </div>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
                onValidate={isVideoUrlValid}
                placeholder='URL do vídeo'
                shouldValidate={submitAttempt}
                maxLength={100}
                warningMsg='A URL do vídeo precisa ser informada com um vídeo do player Vimeo.'
            />

            <div className='container-save-form'>
                <button className='gray-button cancel-create-class' onClick={() => onClose()}>Cancelar</button>

                <button
                    type='submit'
                    onClick={onClickSave}
                    className='blue-button zoom-effect'>
                    Salvar
                </button>
            </div>
        </form>
    );
}

export default CreateClass;